import { render, staticRenderFns } from "./switchyesno.vue?vue&type=template&id=1a6ece7c&"
import script from "./switchyesno.vue?vue&type=script&lang=js&"
export * from "./switchyesno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports